export let Project = {
  RevenueCat: {
    apple: 'appl_',
    google: 'goog_',
  },
  api: 'https://api.hoxtonmix.com/api/v3/',
  apiAuth: '',
  cognito: {
    region: 'eu-west-2',
    userPoolId: 'eu-west-2_MosuWzxeS',
    userPoolWebClientId: 'kkfdljdu05b9ki79i82cfev4b',
  },
  companyAPI: 'https://api.hoxtonmix.com/api/v3/',
  currency: 'GBP',
  customerPortalURL: 'https://account.hoxtonmix.com',
  dataRelay: '1637-c53c-21bc',
  debug: false,
  defaultLocation: {
    'address_line_1': '66 Paul Street',
    'address_line_2': null,
    'city': 'London',
    'country': 'GB',
    'id': 1,
    'name': '66 Paul Street',
    'postal_code': 'EC2A 4NA',
    'state': 'England',
  },
  flagsmith: 'VaJCp6TC2mwxRvKmeKNFUs',
  ga: '',
  headers: {},
  locale: 'en-gb',
  logs: {
    API: false,
    COGNITO: false,
    DATA: false,
    DISPATCHER: false,
    EVENTS: true,
    PUSH_NOTIFICATIONS: false,
    SERVER: false,
    STORAGE: false,
    STORE: false,
  },
  loqate: 'PR28-BF96-PB24-GY46',
  sentry:
    'https://2434988c9e0d3757db35049c7cd6c8fb@o31090.ingest.us.sentry.io/4509716992425984',
  sentryEnvironment: 'production',
}

export function setProject(newProject) {
  Project = newProject
}
